enum LisioMessageReceivedName {
  ACTIVE_RESPONSE = "active_response",
  ALL_ENCODED_RESPONSE = "all_encoded_response",
  BULK_FEATURES = "bulk_features",
  CLOSE_WIDGET = "close_widget",
  DISABLE_ALL = "disable_all",
  ENCODE_PROFILES_RESPONSE = "encode_profiles_response",
  FEATURE = "feature",
  INIT_FRONT = "init_front",
  LOAD_FRONT = "load_front",
  NEW_TAB = "new_tab",
  PROFILS_RESPONSE = "profiles_response",
  READING_MODE_RESPONSE = "reading_mode_response",
  TRANS_BANNER_POPUP = "trans_banner_popup",
  TRANSLATION_LANGUAGE_CHANGE = "translation_language_change",
  TRANSLATOR_API_TRANSLATE_RESPONSE = "translator_api_translate_response",
  DICO_API_RESPONSE = "dico_api_response",
}

export default LisioMessageReceivedName;
